import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,
ReferenceInput, SelectInput,NumberField,Tab,TabbedShowLayout
 }
from 'admin-on-rest/lib/mui';
const fieldStyle = ({record}) => {
   /* alert (record);
    if (record <0) return { backgroundColor: '#fdd' };
    */
    return { backgroundColor: '#fdd' };
};
/*
<span style={elStyle}>{value.toLocaleString(locales, options)}</span>;
*/
const colored = WrappedComponent => props =>
{
    
switch(true) {
    case (props.record[props.source]>2):
    return <span style={{ color: 'white',backgroundColor:'red' }}><WrappedComponent {...props} /></span> 
    
        break;

    case (props.record[props.source]>1):
    return <span style={{ backgroundColor: 'yellow' }}><WrappedComponent {...props} /></span> 
    
        break;
   
    default:
    return <WrappedComponent {...props} />;
}

}



const ColoredTextField = colored(NumberField);

export const RisksList = (props) => (
    <List title="ניהול סיכונים - חודש נוכחי מול ממוצע" {...props}>
        <Datagrid>
        <TextField  label="בית עסק" source="name_heb" />
        
        
        
        <ColoredTextField label="סהכ מספר עסקאות תייר" locales="he-IL" source="TayarCount" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }} />
        <ColoredTextField label="סהכ עסקאות תייר" locales="he-IL" source="TayarSum" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<ColoredTextField label="ממוצע עסקת תייר" locales="he-IL" source="TayarAvg" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<ColoredTextField label="סהכ מספר עסקאות מזומן" locales="he-IL" source="MezumanCount" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<ColoredTextField label="סהכ עסקאות מזומן" locales="he-IL" source="MezumanSum" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<ColoredTextField label="ממוצע עסקת מזומן" locales="he-IL" source="MezumanAvg" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<ColoredTextField label="סהכ מספר עסקאות תשלומים" locales="he-IL" source="TashlumimCount" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<ColoredTextField label="סהכ עסקאות תשלומים" locales="he-IL" source="TashlumimSum" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<ColoredTextField label="ממוצע עסקת תשלומים" locales="he-IL" source="TashlumimAvg" options={{ style: 'percent', minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
             
            
             
           
            
            
            
            
            
<ShowButton /> 
            
        </Datagrid>
    </List>
);


const RisksTitle = ({ record }) => {
    return <span>ניהול סיכונים {record ? `"${record.name_heb}"` : ''}</span>;
};


const HafkadotStyle = {
    width:500,
      minHeight: 100,
      marginLeft: '2em',
      display: 'inline-block',
      verticalAlign: 'top'
  };

  
export const RisksShow = (props) => (
     
    <Show title={<RisksTitle />} {...props}>
     <TabbedShowLayout >
        <Tab label="עסקאות תייר">
        <NumberField style={HafkadotStyle} elStyle={{minHeight: 180 }} label="סהכ מספר עסקאות תייר" locales="he-IL" source="TayarCountThisMonth" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }} />
        <NumberField style={HafkadotStyle} elStyle={{minHeight: 180 }} label="סהכ מספר עסקאות תייר - ממוצע" locales="he-IL" source="TayarCount3Months" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }} />

        <NumberField style={HafkadotStyle} label="סהכ עסקאות תייר" locales="he-IL" source="TayarSumThisMonth" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
        <NumberField style={HafkadotStyle} label="סהכ עסקאות תייר - ממוצע" locales="he-IL" source="TayarSum3Months" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<NumberField style={HafkadotStyle} label="ממוצע עסקת תייר" locales="he-IL" source="TayarAvgThisMonth" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<NumberField style={HafkadotStyle} label="ממוצע עסקת תייר - ממוצע" locales="he-IL" source="TayarAvg3Months" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>

        </Tab>
        <Tab label="עסקאות מזומן">

<NumberField style={HafkadotStyle} label="סהכ מספר עסקאות מזומן" locales="he-IL" source="MezumanCountThisMonth" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<NumberField style={HafkadotStyle} label="סהכ מספר עסקאות מזומן - ממוצע" locales="he-IL" source="MezumanCount3Months" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<NumberField style={HafkadotStyle} label="סהכ עסקאות מזומן" locales="he-IL" source="MezumanSumThisMonth" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<NumberField style={HafkadotStyle} label="סהכ עסקאות מזומן - ממוצע" locales="he-IL" source="MezumanSum3Months" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<NumberField style={HafkadotStyle} label="ממוצע עסקת מזומן" locales="he-IL" source="MezumanAvgThisMonth" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<NumberField style={HafkadotStyle} label="ממוצע עסקת מזומן - ממוצע" locales="he-IL" source="MezumanAvg3Months" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>

        </Tab>
        <Tab label="עסקאות תשלומים">

<NumberField style={HafkadotStyle} label="סהכ מספר עסקאות תשלומים" locales="he-IL" source="TashlumimCountThisMonth" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<NumberField style={HafkadotStyle} label="סהכ מספר עסקאות תשלומים - ממוצע" locales="he-IL" source="TashlumimCount3Months" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<NumberField style={HafkadotStyle} label="סהכ עסקאות תשלומים" locales="he-IL" source="TashlumimSumThisMonth" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<NumberField style={HafkadotStyle} label="סהכ עסקאות תשלומים - ממוצע" locales="he-IL" source="TashlumimSum3Months" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<NumberField style={HafkadotStyle} label="ממוצע עסקת תשלומים" locales="he-IL" source="TashlumimAvgThisMonth" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
<NumberField style={HafkadotStyle} label="ממוצע עסקת תשלומים - ממוצע" locales="he-IL" source="TashlumimAvg3Months" options={{  minimumFractionDigits: 1,maximumFractionDigits: 2 }}/>
        </Tab>
    </TabbedShowLayout>

   
        </Show>
    );
    
              



// WEBPACK FOOTER //
// ./src/components/RiskManagement/Risks/risks.js